/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import 'react-alice-carousel/lib/alice-carousel.css';
import React, { useEffect, useState } from 'react';

function getWindowDimensions() {
    if (typeof window !== 'undefined') {
        const { innerWidth: width } = window;
        return {
            width,
        };
    } else {
        return {
            width: null,
        };
    }
}

function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}

export default function ButtonsNextPrevSlider(props): JSX.Element {
    const { attribute, inactiveNext, setInactiveNext, inactivePrev, setInactivePrev, slider, setSlider, propSlider } =
        props;
    const { width } = useWindowDimensions();
    const [separator, setSeparator] = useState(attribute.separator);

    useEffect(() => {
        if (width && width < 640) {
            setSeparator(1);
        }
    }, []);

    const slideNext = () => {
        if (slider.currentIndex <= slider.items.length - separator) {
            setSlider({ ...slider, currentIndex: slider.currentIndex + separator });
            setInactiveNext(false);
        } else {
            setInactiveNext(true);
        }
    };

    const slidePrev = () => {
        if (slider.currentIndex > 0) {
            setSlider({ ...slider, currentIndex: slider.currentIndex - separator });
            setInactivePrev(true);
        } else {
            setInactivePrev(false);
        }
    };

    useEffect(() => {
        if (slider.currentIndex === 0) {
            setInactiveNext(false);
            setInactivePrev(true);
        } else {
            if (slider.currentIndex < separator) {
                setInactiveNext(false);
                setInactivePrev(true);
            } else {
                setInactivePrev(false);
                if (
                    (slider.items && slider.currentIndex === slider.items.length) ||
                    (slider.items && slider.currentIndex + separator - 1 === slider.items.length)
                ) {
                    setInactiveNext(true);
                } else {
                    setInactiveNext(false);
                }
            }
        }
    }, [slider]);

    const buttonPrev = () => {
        const prev = (
            <button
                type="button"
                disabled={inactivePrev}
                className={`${
                    inactivePrev
                        ? 'bg-gray-300 hover:bg-gray-300 opacity-80'
                        : `${attribute.color.bgButton} ${attribute.color.hover.bg} ${attribute.color.hover.text}`
                } w-16 h-16 border-2 border-white inline-flex items-center justify-center p-2 rounded-full text-white  focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white`}
                onClick={() => slidePrev()}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-8 w-8"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                </svg>
            </button>
        );
        return prev;
    };
    const buttonNext = () => {
        const next = (
            <button
                type="button"
                disabled={inactiveNext}
                className={`${
                    inactiveNext
                        ? 'bg-gray-300 hover:bg-gray-300 opacity-80'
                        : `${attribute.color.bgButton} ${attribute.color.hover.bg} ${attribute.color.hover.text}`
                } w-16 h-16 border-2 border-white inline-flex items-center justify-center p-2 rounded-full text-white  focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white`}
                onClick={() => slideNext()}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-8 w-8"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        );
        return next;
    };

    return (
        <>
            <div role="Button-Displacement" className="hidden sm:block">
                <div className="absolute z-40 right-0">
                    <div className={`${propSlider.hButton} pr-8 flex items-center`}>{buttonNext()}</div>
                </div>
                <div className="absolute z-40 left-0">
                    <div className={`${propSlider.hButton} pl-8 flex items-center`}>{buttonPrev()}</div>
                </div>
            </div>
        </>
    );
}
